import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 2h-10a3 3 0 0 0 -3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3 -3v-14a3 3 0 0 0 -3 -3z","key":"svg-0"}]]

const IconRectangleVerticalFilled = createReactComponent('filled', 'rectangle-vertical-filled', 'RectangleVerticalFilled', __iconNode);

export default IconRectangleVerticalFilled;